import Module from './probe.js';

export default async function makeProbe(createInstance) {
    const module = await Module({
        instantiateWasm: createInstance && ((info, recv) => (createInstance(info, recv),{})),
    });

    const cProbeFile = module.cwrap('probe_file', 'number', ['number'], { async: true });
    const cFileInfoVideoWidth = module.cwrap('file_info_video_width', 'number', ['number']);
    const cFileInfoVideoHeight = module.cwrap('file_info_video_height', 'number', ['number']);
    const cFileInfoVideoDuration = module.cwrap('file_info_video_duration', 'number', ['number']);
    const cFileInfoVideoFramerateNum = module.cwrap('file_info_video_framerate_num', 'number', ['number']);
    const cFileInfoVideoFramerateDen = module.cwrap('file_info_video_framerate_den', 'number', ['number']);
    const cFreeFileInfo = module.cwrap('free_file_info', 'void', ['number']);

    const cLastErrorMessage = module.cwrap('last_error_message', 'number', []);
    const cFreeString = module.cwrap('free_string', 'void', ['number']);

    function lastErrorMessage() {
        const pMsg = cLastErrorMessage();
        try {
            return module.UTF8ToString(pMsg);
        } finally {
            cFreeString(pMsg);
        }
    }

    return async function probe(file) {
        const fileId = module.avio_openFile(file);
        const pFileInfo = await cProbeFile(fileId);
        try {
            if (!pFileInfo) {
                throw new Error(lastErrorMessage());
            }

            return {
                width: cFileInfoVideoWidth(pFileInfo),
                height: cFileInfoVideoHeight(pFileInfo),
                framerate: cFileInfoVideoFramerateNum(pFileInfo)/cFileInfoVideoFramerateDen(pFileInfo),
                duration: cFileInfoVideoDuration(pFileInfo),
            };
        } finally {
            cFreeFileInfo(pFileInfo);
            module.avio_closeFile(fileId);
        }
    }
}
